import { apiRequest } from '@/lib/apiClient';
import type { Role, User } from '@/types';

export interface CreateUserInput {
  displayName: string;
  username: string;
  password: string;
  role: Role;
  numeroMecanografico?: string | null;
  categoria?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  naEmpresaDesde?: string | null;
  horasAlvoDiarias?: number | null;
}

export type UpdateUserInput = Partial<Omit<CreateUserInput, 'password'>> & { ativo?: boolean };

export function fetchUsers(): Promise<User[]> {
  return apiRequest<User[]>('/api/users');
}

export function createUser(input: CreateUserInput): Promise<User> {
  return apiRequest<User>('/api/users', { method: 'POST', body: input });
}

export function updateUser(id: string, input: UpdateUserInput): Promise<User> {
  return apiRequest<User>(`/api/users/${id}`, { method: 'PUT', body: input });
}

export function resetPassword(id: string, newPassword?: string): Promise<{ codigo: string }> {
  return apiRequest<{ codigo: string }>(`/api/users/${id}/reset-password`, {
    method: 'POST',
    body: { newPassword },
  });
}

export function deleteUser(id: string): Promise<void> {
  return apiRequest<void>(`/api/users/${id}`, { method: 'DELETE' });
}
